<template>
  <div id="video" class="centerHorizontalAbsoluteOT"></div>
</template>

<script>
import OT from "@opentok/client";

export default {
  name: "Publisher",
  props: {
    session: { type: OT.Session, required: false },
    endPoint: { type: String, required: true },
    sessionId: { type: String, required: true },
    token: { type: String, required: true }
  },
  data() {
    return {
      width: 640,
      height: 480,
      publisher: undefined,
      options: {
        width: this.width,
        height: this.height,
        mirror: true,
        resolution: "640x480",
        frameRate: 15,
        facingMode: "user",
        fitMode: "contain",
        style: {
          buttonDisplayMode: "auto",
          nameDisplayMode: "on",
          insertMode: "append"
        }
      }
    };
  },
  created() {
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isIPad = /iPad/.test(navigator.userAgent) && !window.MSStream;
    this.isMacintosh =
      /Macintosh/.test(navigator.userAgent) && !window.MSStream;
    this.isAndroid = /Android/.test(navigator.userAgent) && !window.MSStream;
    this.isFirefox = /Firefox/.test(navigator.userAgent) && !window.MSStream;
    this.isIOSChrome =
      /Chrome&CriOS/.test(navigator.userAgent) && !window.MSStream;
    this.isIE11 = /Trident/.test(navigator.userAgent) && !window.MSStream;
    this.isEdge = /Edge/.test(navigator.userAgent);
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.isOpera = /Opera/.test(navigator.userAgent) && !window.MSStream;
    this.isChrome = /Chrome/.test(navigator.userAgent) && !window.MSStream;
    // TODO remover
    // this.isIOS = true;

    // Get width and heigth and if the orientation is portrait or landscape
    this.isPortrait = false;
    this.isPortraitTablet = false;
    if (window.outerHeight > window.outerWidth && !this.isDesktop) {
      this.isPortrait = true;
      this.isPortraitTablet = true;
    }

    if (
      this.isIOS ||
      this.isIPad ||
      this.isSafari ||
      this.isIE11 ||
      this.isEdge
    ) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isPortrait = false;
        this.isPortraitTablet = false;
        if (window.innerHeight > window.innerWidth) {
          this.isPortrait = true;
          this.isPortraitTablet = true;
        }
        if (this.isPortrait) {
          this.width = 240;
          this.height = 320;
        } else {
          this.width = 320;
          this.height = 240;
        }
      }
      this.EventBus.$on("stopRecording", () => {
        this.stopArchive();
      });
      this.EventBus.$on("sessionDisconnect", () => {
        this.session.disconnect();
        // this.session.forceDisconnect();
      });
      this.EventBus.$on("portrait", () => {
        var video = document.getElementById("video");
        video.style.cssText = "width: 240px; height: 320px; overflow: hidden;";
        this.width = 240;
        this.height = 320;
      });
      this.EventBus.$on("landscape", () => {
        var video = document.getElementById("video");
        video.style.cssText = "width: 320px; height: 240px; overflow: hidden;";
        this.width = 240;
        this.height = 320;
      });
    }
  },
  mounted() {
    this.options.width = this.width;
    this.options.height = this.height;
    this.publisher = OT.initPublisher(this.$el, this.options, err => {
      if (err) {
        this.$emit("error", err);
      } else {
        this.$emit("publisherCompleted");
      }
    });
    this.$emit("publisherCreated", this.publisher);
    const publish = () => {
      this.session.publish(this.publisher, err => {
        if (err) {
          this.$emit("error", err);
          this.EventBus.$emit("cannotInitIdentification");
        } else {
          this.$emit("publisherConnected", this.publisher);
          this.EventBus.$emit("setPublisher", this.publisher);
          this.startArchive();
        }
      });
    };
    if (this.session && this.session.isConnected()) {
      publish();
    }
    if (this.session) {
      this.session.on("sessionConnected", publish);
      // session.on('sessionConnected', function(event) {
      //   $scope.sessionConnectedHandlerFromMobile(event)
      // })
      this.session.on("archiveStarted", event => {
        this.archiveId = event.id;
        // console.log(`${'Archive started '}${event.id}`);
      });
      this.session.on("archiveStopped", event => {
        // $scope.archiveID = event.id
        // console.log(`${'Archive stopped '}${event.id}`);
      });
      this.session.on("sessionDisconnected", event => {
        console.log(
          `${"You were disconnected from the session."}${event.reason}`
        );
        // if(event.reason.indexOf('networkTimedout') !== -1) {
        //     $scope.isVideoID = false
        //     $timeout.cancel(endVideoTimeout)
        //     if(window.self !== window.top) {
        //         $rootScope.$broadcast('rejectOperation', false)
        //         $scope.setOperationStateToError()
        //         window.parent.postMessage({type: 'closeOperation', status: '02'}, '*')
        //     }
        // } else if(event.reason.indexOf('networkDisconnected') !== -1) {
        //     $scope.isVideoID = false
        //     $timeout.cancel(endVideoTimeout)
        //     if(window.self !== window.top) {
        //         $rootScope.$broadcast('rejectOperation', false)
        //         $scope.setOperationStateToError()
        //         window.parent.postMessage({type: 'closeOperation', status: '02'}, '*')
        //     }
        // } else if(event.reason.indexOf('clientDisconnected') !== -1) {

        // } else if(event.reason.indexOf('forceDisconnected') !== -1) {

        // }
        // disconnectCamera()
      });
      this.session.on("streamPropertyChanged", event => {
        console.log(
          `${"Han cambiado las propiedades del stream."}${event.reason}`
        );
      });
    }
  },
  methods: {
    startArchive() {
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http.post(`${this.endPoint}${"start/"}${this.sessionId}`).then(
        response => {
          console.log("video archive start");
          this.EventBus.$emit("initDetections");
        },
        error => {
          console.log("video archive start error");
          this.EventBus.$emit("cannotInitIdentification");
        }
      );
    },
    stopArchive() {
      this.$http.defaults.headers.common.Authorization = this.token;
      this.$http.post(`${this.endPoint}${"stop/"}${this.archiveId}`).then(
        response => {
          console.log("video archive stop");
          this.session.disconnect();
          // this.session.forceDisconnect();
          this.EventBus.$emit("calculateVideoParams");
        },
        error => {
          console.log("video archive stop error");
          this.EventBus.$emit("error", "Can´t save video");
        }
      );
    },
    addPublisher() {
      this.session.unpublish(this.publisher);
      var sessionEl = document.getElementById("session");
      var videoEl = document.createElement("publisher");
      videoEl.session = this.session;
      videoEl.endPoint = this.endPoint;
      videoEl.token = this.token;
      videoEl.sessionId = this.sessionId;
      videoEl.id = "publisherContainer";
      sessionEl.appendChild(videoEl);
    }
  }
};
</script>
